import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import { fluidRange } from 'polished';
import { linkResolver } from '../../utils/linkResolver';

const TitleText = ({ slice }) => {
    const parseHeading = () => {
        if (slice.title_textTitle) {
            return <SHeading>{RichText.render(slice.title_textTitle)}</SHeading>;
        }
    };
    return (
        <>
            {parseHeading()}
            <SText>{RichText.render(slice.title_textText, linkResolver)}</SText>
        </>
    );
};

const SHeading = styled.div`
    ${fluidRange(
        {
            prop: 'font-size',
            fromSize: '19px',
            toSize: '23px'
        },
        '320px',
        '1440px'
    )}
    margin-bottom: 16px;
    font-weight: 700;

    * + & {
        margin-top: 40px;
    }
`;

const SText = styled.div`
    ${fluidRange(
        {
            prop: 'font-size',
            fromSize: '17px',
            toSize: '19px'
        },
        '320px',
        '1440px'
    )}
    line-height: 1.5;

    > * + * {
        margin-top: 20px;
    }

    h2 + p,
    h3 + p,
    h4 + p {
        margin-top: 4px;
    }

    & + ${SHeading} {
        margin-top: 36px;
    }

    a {
        color: var(--color-secondary);
        text-decoration: underline;
    }

    strong {
        font-weight: 700;
    }

    h2,
    h3,
    h4 {
        font-weight: 700;

        * + & {
            margin-top: 40px;
        }
    }

    h2 {
        ${fluidRange(
            {
                prop: 'font-size',
                fromSize: '19px',
                toSize: '23px'
            },
            '320px',
            '1440px'
        )}
    }

    h3 {
        ${fluidRange(
            {
                prop: 'font-size',
                fromSize: '19px',
                toSize: '21px'
            },
            '320px',
            '1440px'
        )}
    }

    h4 {
        ${fluidRange(
            {
                prop: 'font-size',
                fromSize: '18px',
                toSize: '19px'
            },
            '320px',
            '1440px'
        )}
    }
`;

export default TitleText;

TitleText.propTypes = {
    slice: PropTypes.object.isRequired
};
